export default "__VITE_ASSET__cadd72b1__"